<template>
    <div class="coupon">
        <!--add new coupon-->
        <div v-if="!isOpen" class="coupon-add">
            <span class="coupon-add__title">{{ messages.iHaveCoupon }}</span>
            <button
                type="button"
                class="coupon-add__button"
                @click.prevent="isOpen = true"
            >
                <svg><use xlink:href="#svg-plus"></use></svg>
                <DefLink>
                    {{ messages.add }}
                </DefLink>
            </button>
        </div>
        <!--input new coupon-->
        <div v-else class="coupon-apply">
            <div class="coupon-apply__header">
                <span class="coupon-apply__title">{{ messages.iHaveCoupon }}</span>
                <button
                    type="button"
                    @click.prevent="closeCoupon"
                    class="coupon-apply__hide"
                >
                    {{ messages.cancel }}
                </button>
            </div>

            <DefInput
                v-model="coupon"
                :placeholder="messages.code"
                :readonly="isError"
                :isError="isError"
            />
            <DefButtonPrimary v-if="coupon && !isError" @click="applyCoupon">
                {{ messages.apply }}
            </DefButtonPrimary>
            <DefButtonSecondary v-else-if="!isError">
                {{ messages.apply }}
            </DefButtonSecondary>

            <!--error message-->
            <DefMessageError v-if="isError">
                {{ messages.wrong }}
            </DefMessageError>
            <!--success message-->
            <!--                <DefMessageSuccess>-->
            <!--                    {{ messages.applied }}-->
            <!--                </DefMessageSuccess>-->
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import DefInput from "../../def/DefInput/DefInput";
import DefLink from "../../def/DefLink/DefLink";
import DefButtonPrimary from "../../def/DefButtonPrimary/DefButtonPrimary";
import DefButtonSecondary from "../../def/DefButtonSecondary/DefButtonSecondary";
import DefMessageError from "../../def/DefMessages/DefMessageError";
import DefMessageSuccess from "../../def/DefMessages/DefMessageSuccess";

export default {
    name: 'Coupon',
    components: {
        DefInput,
        DefLink,
        DefButtonPrimary,
        DefButtonSecondary,
        DefMessageError,
        DefMessageSuccess
    },
    props: ['result'],
    data() {
        return {
            isOpen: false,
            coupon: '',
            isError: false,
        }
    },
    computed: {
        ...mapState({
            basket: ({basket}) => basket.data,
            messages: ({basket}) => basket.data?.messages?.coupons,
        }),
    },
    methods: {
        ...mapActions({
            setCoupon: 'basket/setCoupon',
            deleteCoupon: 'basket/deleteCoupon',
            setAjax: 'checkout/setAjax',
        }),
        /**
         * @todo оформить
         * @param e
         * @returns {Promise<void>}
         */
        async applyCoupon(e) {
            try {
                if (this.coupon) {
                    const response = await this.setCoupon(this.coupon);
                    const coupons = response?.price?.coupons;

                    if (coupons && this.coupon in coupons) {
                        this.closeCoupon();
                        this.setAjax();
                    } else {
                        this.isError = true;
                    }
                }
            } catch (err) {
                console.error(err);
            }
        },
        closeCoupon() {
            this.isOpen = false;
            this.isError = false;

            if (this.coupon) {
                this.coupon = '';
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.coupon{
    background: #fff;
    padding: 24px;
}
.coupon-add{
    display: flex;
    align-items: center;
    justify-content: space-between;
    &__title{
        font-size: rem(16);
        line-height: 125%;
        font-weight: 500;
    }
    &__button{
        display: flex;
        align-items: center;
        background-color: transparent;
        line-height: 100%;
        svg{
            display: block;
            width: 14px;
            height: 14px;
            margin-right: 8px;
        }
        span{
            text-decoration: underline;
            text-underline-position: under;
        }
    }
}
.coupon-apply{
    display: grid;
    grid-row-gap: 24px;
    &__header{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    &__title{
        font-size: rem(16);
        line-height: 125%;
        font-weight: 500;
    }
    &__hide{
        background-color: transparent;
        text-decoration: underline;
        text-underline-position: under;
    }
    &__message{
        display: flex;
        align-items: center;
        height: 40px;
        background: #F7EFEF;
        color: #E20712;
        padding: 0 16px;
        cursor: pointer;
        svg{
            display: block;
            width: 16px;
            height: 16px;
            margin-right: 8px;
        }
        span{
            transform: translateY(2px);
        }
        &_error{
            color: #E20712;
            background: #F7EFEF;
        }
        &_success{
            color: #689575;
            background: #E4EEE7;
        }
    }
    :deep(.def-input-component){
        height: auto;
    }
    :deep(.def-input-component__input){
        //background-color: transparent;
    }
    :deep(.def-button-secondary){
        cursor: not-allowed;
        border: 1px solid var(--color-grey);
        color: #5F5F67;
    }
}
</style>